<template>
  <v-app>
    <v-container v-if="visible">
      <div id="canvasBox" :style="{ width: isMobile ? '1000px': '90%'}">
        <div :style="{width: isMobile ? padWidth : '100%'}">
          <span style="font-size: 20px;">{{msg}}</span>
          <a style="margin: 20px; padding: 5px; font-size: 24px; border: 1px solid royalblue;" @touchstart="clear"
            @mousedown="clear">清除重寫</a>
          <a style="margin: 20px; padding: 5px; font-size: 24px; border: 1px solid royalblue;" @touchstart="undo"
            @mousedown="undo">回上一步</a>
          <a style="margin: 20px; padding: 5px; font-size: 24px; border: 1px solid royalblue;" @touchstart="download"
            @mousedown="download">確定</a>
          <a v-if="isMobile"
            style="margin-left: 20px; padding: 5px; font-size: 24px; border: 1px solid royalblue; float: right;"
            @touchstart="download" @mousedown="download">確定</a>
          <a v-if="isMobile"
            style="margin-left: 20px; padding: 5px; font-size: 24px; border: 1px solid royalblue; float: right;"
            @touchstart="undo" @mousedown="undo">回上一步</a>
          <a v-if="isMobile"
            style="margin-left: 20px; padding: 5px; font-size: 24px; border: 1px solid royalblue; float: right;"
            @touchstart="clear" @mousedown="clear">清除重寫</a>

          <div style="float: right;">
            <v-btn color="red" text dark @mousedown="closeDialog">
              取消
            </v-btn>
          </div>
        </div>

        <!--<canvas ref="canvasBox"></canvas>-->
        <VueSignaturePad :style="{overflow:'auto', margin: '30px' }"
                        :width="padWidth"
                        :height="padHeight"
                        ref="signaturePad"
                        :options="{ minWidth: 2, maxWidth: 7 , penColor:'blue', onBegin: () => {$refs.signaturePad.resizeCanvas()} }"
                        :customStyle="{ border: 'red 3px dashed', backgroundColor: backgroundColor ? backgroundColor :'#ffffff' }"/>
        <br/>
        <!--<v-btn v-if="isMobile"-->
          <!--color="pink"-->
          <!--dark-->
          <!--large-->
          <!--absolute-->
          <!--bottom-->
          <!--right-->
          <!--fab @click="download">-->
          <!--<span>確定</span>-->
        <!--</v-btn>-->
        <span v-if="isMobile" class="display-1" style="color: red; ">可以向右滑動簽名<span class="tip">->>></span></span>
      </div>
    </v-container>

  </v-app>
</template>

<script>
import MobileDetect from 'mobile-detect';
import Draw from '../pages/utils/draw';
const md = new MobileDetect(window.navigator.userAgent);
// import SignaturePad from '../../node_modules/signature_pad';
export default {
  name: 'DrawCanvas',
  props: {
    backgroundColor:String,
    visible: Boolean,
  },
  data() {
    console.log(`${md.phone()} / ${md.os()}`);
    return {
      msg: '請在下方手寫簽名',
      degree: 0, // 屏幕整体旋转的角度, 可取 -90,90,180等值
      scope: [
        {
          value: 0,
          title: '正常',
        },
        {
          value: 90,
          title: '順時針旋轉90°',
        },
        {
          value: 180,
          title: '順時針旋轉180°',
        },
        {
          value: -90,
          title: '逆時針旋轉90°',
        },
      ],
      turn: 0.5,
      // padHeight: md.phone() ? '35%' : '50%',
      padWidth: md.phone() ? '1000px' : '100%',
      // padWidth: '800px',
      padHeight: md.phone() && md.os() === 'AndroidOS' ? '300px' : '500px',
      // padHeight: '50%',
      isMobile: md.phone(),
    };
  },
  components: {
    Draw
  },
  created() {
    console.log(`${this.padWidth} / ${this.padHeight}`);
  },
  watch: {
    visible(value){
      console.log(`draw === ${value}`);
      if (value === true){
        this.clear();
      }
    }
  },
  mounted() {
    // this.canvasBox = document.getElementById('canvasBox');
    // this.initCanvas();
    // this.clear();
  },
  computed: {
    getHorizontalStyle() {
      const d = document;
      const w = window.innerWidth || d.documentElement.clientWidth || d.body.clientWidth;
      const h = window.innerHeight || d.documentElement.clientHeight || d.body.clientHeight;
      let length = (h - w) / 2;
      let width = w;
      let height = h;
      switch (this.degree) {
        case -90:
          length = -length;
        case 90:
          width = h;
          height = w;
          break;
        default:
          length = 0;
      }
      if (this.canvasBox) {
        this.canvasBox.removeChild(document.querySelector('canvas'));
        this.canvasBox.appendChild(document.createElement('canvas'));
        // setTimeout(() => {
        //     this.initCanvas();
        // }, 200);
      }
      return {
        transform: `rotate(${this.degree}deg) translate(${length}px,${length}px)`,
        width: `${width}px`,
        height: `${height}px`,
        transformOrigin: 'center center',
      };
    },
  },
  methods: {
    rotate() {
      this.degree = this.degree === 0 ? 90 : 0;
    },
    initCanvas() {
      const canvas = document.querySelector('canvas');
      this.draw = new Draw(canvas, -this.degree);
    },
    clear() {
      // this.draw.clear();
      this.$refs.signaturePad.clearSignature();
    },
    download() {
      // this.draw.downloadPNGImage(this.draw.getPNGImage());
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      console.log(isEmpty);
      console.log(data);
      this.$emit('handleDownloadSign', data);
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    closeDialog() {
      console.log(`closeDialog`)
      this.$emit('closeEvent');
    },
    upload() {
      const image = this.draw.getPNGImage();
      const blob = this.draw.dataURLtoBlob(image);
      const url = '';
      const successCallback = (response) => {
        console.log(response);
      };
      const failureCallback = (error) => {
        console.log(error);
      };
      this.draw.upload(blob, url, successCallback, failureCallback);
    },
  },
};
</script>

<style scoped>
  #canvasBox {
    display: flex;
    flex-direction: column;
    height: 70%;
    width: 60%;
  }

  .tip{
    animation: blink 1s steps(1) infinite;
  }
  @keyframes blink{
    50% {
      color: transparent;
    }
  }

  .float-button {
    width:200px;
    display:inline-block;
    overflow: auto;
    white-space: nowrap;
    margin: 0 auto;
    border:1px red solid;
  }
</style>



// WEBPACK FOOTER //
// src/components/DrawCanvas.vue